import { useQuery } from '@tanstack/react-query';
import { IBudget } from 'types';
import { useApi } from './useApi';

export const useOrders = () => {
  const api = useApi();
  return useQuery<IBudget[]>(['orders'], () => api.getOrders());
};
